export default __webpack_public_path__ + "static/media/Google_2015_logo.64742f64.svg";